var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberDashboardNavbarSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 168,
    viewBox: "0 0 78 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.52 83.8302C36.52 90.479 37.7223 97.0627 40.0581 103.205C42.394 109.348 45.8176 114.93 50.1337 119.631C54.4498 124.332 59.5737 128.062 65.2129 130.606C70.8521 133.151 76.8962 134.46 83 134.46L83 83.8302H36.52Z",
    fill: "#FFC556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.52 83.83C36.52 77.1811 37.7223 70.5974 40.0581 64.4547C42.394 58.312 45.8176 52.7306 50.1337 48.0291C54.4498 43.3277 59.5737 39.5983 65.2129 37.0539C70.8521 34.5095 76.8962 33.2 83 33.2L83 83.83H36.52Z",
    fill: "#8DD5AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3827 157.005L48.7795 129.587L61.0391 137.116L40.3827 157.005Z",
    fill: "#FFC556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7102 166.936L64.261 138.784L78.6201 139.681L69.7102 166.936Z",
    fill: "#FFC556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3625 137.113L35.9185 114.441L44.7204 125.821L18.3625 137.113Z",
    fill: "#FFC556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3461 112.789L28.2861 97.0053L32.9387 110.619L4.3461 112.789Z",
    fill: "#FFC556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0887887 84.6658L27.9219 77.7693L27.7681 92.1556L0.0887887 84.6658Z",
    fill: "#FFC556"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0866841 84.6658L27.9198 77.7693L27.9198 85.49L0.0866841 84.6658Z",
    fill: "#8DD5AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83114 55.8174L33.2328 59.7657L27.7403 73.0631L4.83114 55.8174Z",
    fill: "#8DD5AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9063 31.0108L44.1993 44.5203L34.4543 55.1045L18.9063 31.0108Z",
    fill: "#8DD5AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1796 10.5189L60.9045 31.3317L48.3133 38.2922L41.1796 10.5189Z",
    fill: "#8DD5AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6932 0.741876L79.3376 27.7461L65.008 29.0313L69.6932 0.741876Z",
    fill: "#8DD5AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDashboardNavbarSun);
export default __webpack_public_path__ + "static/media/MemberDashboardNavbarSun.226ff32950e3d2a48faf95786562d3f9.svg";
export { ForwardRef as ReactComponent };